import React from 'react';
import './main-layout.scss';
// import { Outlet } from 'react-router-dom';
import Sidebar from '../components/sidebar/Sidebar';
import TopNav from '../components/topnav/TopNav';
import { useLocation } from 'react-router-dom';
const MainLayout = ({ children }) => {
	const location = useLocation();
	console.log(window.location.pathname.split('/')[1]);
	return (
		<>
			<Sidebar />
			<div className='main'>
				<div className='main__content'>
					<TopNav />
					{children}
				</div>
			</div>
		</>
	);
};

export default MainLayout;
